export const PASSWORD_MIN_LENGTH = 8;

export type PasswordCriterionKey = "length" | "uppercase" | "digit";

export interface PasswordCriterion {
  key: PasswordCriterionKey;
  label: string;
  test: (password: string) => boolean;
}

/**
 * Critères de force du mot de passe, partagés par la page d'activation
 * (/set-password) et la fenêtre « Modifier mon mot de passe ».
 * Seule la longueur est obligatoire ; majuscule et chiffre sont recommandés.
 */
export const PASSWORD_CRITERIA: PasswordCriterion[] = [
  { key: "length", label: "Au moins 8 caractères", test: (pw) => pw.length >= PASSWORD_MIN_LENGTH },
  { key: "uppercase", label: "Une majuscule (recommandé)", test: (pw) => /[A-Z]/.test(pw) },
  { key: "digit", label: "Un chiffre (recommandé)", test: (pw) => /\d/.test(pw) },
];

export type PasswordChecks = Record<PasswordCriterionKey, boolean>;

export function getPasswordChecks(password: string): PasswordChecks {
  const checks = {} as PasswordChecks;
  for (const criterion of PASSWORD_CRITERIA) {
    checks[criterion.key] = criterion.test(password);
  }
  return checks;
}

/** Score de 0 à 3 (nombre de critères satisfaits). */
export function getPasswordScore(password: string): number {
  return PASSWORD_CRITERIA.reduce((score, criterion) => score + (criterion.test(password) ? 1 : 0), 0);
}

/** Longueur suffisante : seul critère bloquant, identique à /set-password. */
export function isPasswordLongEnough(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH;
}
